// @flow

// Effect Managers
import { take, call, put } from 'redux-saga/effects'

// Libs
import _get from 'lodash/get'

// Utils
import { getToken } from 'fc-auth'
import getUrl from 'hfty-utils/url'

// Constants
import {
  LOAD_SOIL_PROPS_MAP_DATA,
  REPORT_URL,
  SOIL_PROPERTIES_MAP,
  SOIL_PROPS_PDF_NOT_GENERATED,
} from '../constants'
import { GET } from 'fc-fetch/src/constants'

// Actions
import { setSoilPropsMapBlobId } from '../actions'

export default function *watchLoadSoilPropsMapData (): Generator<*, *, *> {
  while (true) {
    const { fieldId } = yield take(LOAD_SOIL_PROPS_MAP_DATA)
    const token = yield call(getToken)
    const URL = getUrl({
      path: REPORT_URL,
      queryParams: {
        rootAsset: fieldId,
        type: SOIL_PROPERTIES_MAP,
      },
    })
    const response = yield call(fetch, URL, {
      method: GET,
      headers: {
        Authorization: `Token ${token}`,
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
    })
    const json = yield call([response, response.json])
    const soilPropsMapBlobId = _get(json, '[0].blob', SOIL_PROPS_PDF_NOT_GENERATED)

    yield put(setSoilPropsMapBlobId(soilPropsMapBlobId))
  }
}
